import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { Plan } from "../models/plan.model";
import { Observable } from "rxjs";

interface PlansResponse {
  data: Plan[];
}

@Injectable({
    providedIn: 'root'
  })
  export class AccountService {
    
    // Replace with your actual API endpoint
    private baseUrl = `${environment.baseUrl}/api`;
  
    constructor(private http: HttpClient) {
      // Check if user is already logged in
    }

    getInstagramAccounts() {
        return this.http.get(`${this.baseUrl}/instagram-accounts`);
    }
    
    updateUserProfile(data: any) {
        return this.http.post(`${this.baseUrl}/me/update`, data);
    }

    choostInstagramAccount(data: any) {
        return this.http.post(`${this.baseUrl}/instagram-accounts/choose`, data, { observe: 'response' });
    }

    getPlans(): Observable<PlansResponse> {
        return this.http.get<PlansResponse>(`${this.baseUrl}/prices`);
    }

    changePlan(external_price_id: string) {
      return this.http.post(`${this.baseUrl}/subscriptions/change`, {external_price_id});
    }

    cancelPlan() {
      return this.http.post(`${this.baseUrl}/subscriptions/cancel`, {});
    }

    reactivatePlan(){
      return this.http.post(`${this.baseUrl}/subscriptions/reactivate`, {});
    }

    getDefaultPlan() {
      return this.http.get(`${this.baseUrl}/payment-methods/default`);
    }

    changePaymentMethod(external_pm_id: string) {
      return this.http.post(`${this.baseUrl}/payment-methods/change`, {external_pm_id});
    }

    addBalance(amount: number) {
      return this.http.post(`${this.baseUrl}/balance/add`, {amount});
    }

    getBalance() {
      return this.http.get(`${this.baseUrl}/balance/view`);
    }

    manageAutoTopUp(data: any) {
      return this.http.post(`${this.baseUrl}/balance/auto-top-up`, data)
    }

    getInvoices() {
      return this.http.get(`${this.baseUrl}/invoices`)
    }

    requestRefund() {
      return this.http.post(`${this.baseUrl}/refunds/request`, {});
    }
  } 